import React, { useMemo } from "react";
import * as THREE from "three";
import type { Vector3Data } from "../../types/astronomy";
import type { VisualizationScale } from "../../types/astronomy";
import { astronomicalToThree } from "../../astronomy/coordinateSystems";
import { vectorLength } from "../../astronomy/kepler";

interface VelocityVectorProps {
  positionScene: [number, number, number];
  velocityKmS: Vector3Data;
  scale: VisualizationScale;
  visible: boolean;
}

export function VelocityVector({
  positionScene,
  velocityKmS,
  scale,
  visible,
}: VelocityVectorProps) {
  const dir = useMemo(() => {
    const mapped = astronomicalToThree(velocityKmS);
    const len = vectorLength(mapped);
    if (len === 0) return new THREE.Vector3(0, 1, 0);
    return new THREE.Vector3(mapped.x, mapped.y, mapped.z).normalize();
  }, [velocityKmS]);

  const length = useMemo(() => {
    const speed = vectorLength(velocityKmS);
    // Escala visual: 1 km/s → 0.5 m de seta (ajustável)
    return Math.max(0.002, speed * 0.5 * scale.distanceScale * 1_000_000 * 0.0005);
  }, [velocityKmS, scale]);

  if (!visible) return null;

  return (
    <arrowHelper
      args={[
        dir,
        new THREE.Vector3(...positionScene),
        length,
        0xff6644,
        length * 0.25,
        length * 0.15,
      ]}
    />
  );
}
